export default __webpack_public_path__ + "static/N0289-4e8c46a07fbcb5656df1f1f3dc902aa2.png";